import React, { createContext, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { Snackbar, SnackbarContent, IconButton, withStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'

const SnackbarContext = createContext()

const useStyles = makeStyles((theme) => ({
  successMessage: {
    backgroundColor: theme.palette.toast.backgroundSuccess,
    color: theme.palette.toast.color,
    cursor: 'text',
    '&:hover': {
      backgroundColor: theme.palette.toast.backgroundSuccess,
    },
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    userSelect: 'text',
  },
  close: {
    padding: theme.spacing(0.5),
  },
}))

const CustomSnackbar = withStyles((theme) => ({
  anchorOriginTopCenter: {
    [theme.breakpoints.up('sm')]: {
      top: '70px',
    },
  },
}))(Snackbar)

export const SnackbarProvider = ({ children }) => {
  const classes = useStyles()
  const [snackbar, setSnackbar] = useState({ open: false, message: '' })

  const showSnackbar = (message) => {
    setSnackbar({ open: true, message })
  }

  const handleClose = () => {
    setSnackbar({ open: false, message: '' })
  }

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
      <CustomSnackbar
        open={snackbar.open}
        autoHideDuration={null}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <SnackbarContent
          className={classes.successMessage}
          message={
            <span className={classes.message}>
              {snackbar.message}
            </span>
          }
          action={[
            <IconButton key="close" aria-label="close" color="inherit" className={classes.close} onClick={handleClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </CustomSnackbar>
    </SnackbarContext.Provider>
  )
}

SnackbarProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const useSnackbar = () => {
  return useContext(SnackbarContext)
}
